var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArianeinwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.59 30.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.12,25.14l-1.74,5.39H0L12.18,0h6.19l12.18,30.53h-6.57L15.28,6.77l-3.87,9.86-2.51,6.77-.78,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.7,30.55l-5.65-8.47h-5.9v8.47h-6.42v-14.38h13.86c2.57-.77,3.85-2.57,3.85-5.13,0-3.34-2.05-5.39-5.9-5.39h-11.81V0h12.06c7.44,0,12.32,4.11,12.32,11.04,0,4.62-2.31,7.96-5.9,9.75l6.42,9.75h-6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.71,0h6.11V30.55h-6.11V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.07,25.14l-1.74,5.39h-6.38L84.13,0h6.19l12.18,30.53h-6.57l-8.7-23.76-3.87,9.86-2.51,6.77-.78,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.58,0V30.55h-5.31l-13.95-18.59V30.55h-6.64V0h5.31l13.95,18.59V0h6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.2,5.35V0h21.38V5.35h-21.38Zm21.39,19.09v6.11h-21.38V12.22h19.09v5.35h-12.98v6.87h15.27Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArianeinwhite);
export default __webpack_public_path__ + "static/media/Ariane in white.65c3c3751d91352ce8cc397c63a3088f.svg";
export { ForwardRef as ReactComponent };